import { BulkCapabilityResponse } from 'types/capabilities/capabilities'

interface FiatWalletCapabilities {
  isDepositEnabled?: boolean
  isWithdrawEnabled?: boolean
  isPayEnabled?: boolean
  isTransferEnabled?: boolean
}

/**
 * Returns wallet action capabilities from the capabilities management service
 *
 * @param {string} walletLsid - The wallet to fetch wallet action capabilitys for
 * @param {BulkCapabilityResponse} bulkCapabilities - The bulk wallet capabilities response.
 * @returns {FiatWalletCapabilities} - Returns the actions (deposit, pay, withdraw and internal transfers),
 * that a given wallet is enabled for.
 */
export const useFiatWalletCapabilities = (
  walletLsid: string,
  bulkCapabilities: BulkCapabilityResponse
): FiatWalletCapabilities => {
  const walletActionsCapabilityResponse =
    bulkCapabilities.FIAT?.WALLET_ACTIONS?.WALLET?.[walletLsid]
  const actions = walletActionsCapabilityResponse?.value?.toString()?.split(',')

  const walletInternalTransfersCapabilityResponse =
    bulkCapabilities.PAYMENT?.INTERNAL?.WALLET?.[walletLsid]
  const isTransferEnabled = walletInternalTransfersCapabilityResponse?.value === 'true'

  const actionsValue = {
    ...(walletActionsCapabilityResponse &&
      !!walletActionsCapabilityResponse?.value &&
      !walletActionsCapabilityResponse?.error && {
        isDepositEnabled: actions?.includes('deposit'),
        isPayEnabled: actions?.includes('pay'),
        isWithdrawEnabled: actions?.includes('withdraw'),
      }),
  }

  const internalTransferValue = {
    ...(walletInternalTransfersCapabilityResponse &&
      !!walletInternalTransfersCapabilityResponse?.value &&
      !walletInternalTransfersCapabilityResponse?.error && { isTransferEnabled }),
  }

  return {
    ...actionsValue,
    ...internalTransferValue,
  }
}
